// extracted by mini-css-extract-plugin
export default {"ClientDetail":"ClientDetail_ClientDetail__THCFy","tableResponsive":"ClientDetail_tableResponsive__QR+-Y"};